import { CitiesEnum } from './cities-enum';
import { sanitizeCityName } from './sanitize-city-name';

const unexpectedCities: string[] = [];

export const servedCities = [
  ...Object.values(CitiesEnum).map((city) => sanitizeCityName(city)),
  ...unexpectedCities,
];
